import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const usePublishTierMutation = createMutationHook(MembershipsCreatorApiClient.publishTier, {
  mutationKey: ['publishTier'],
})
